import calculateFill from './calculateFill';

const getRenderData = (data) =>
  data.reduce(
    (acc, { name, data: response }) => {
      const maxValue = Math.max(...response.map(({ value }) => value));
      if (maxValue > acc.maxValue) {
        acc.maxValue = maxValue;
      }

      const dataWithFill = response.map((response) => ({
        ...response,
        fill: calculateFill(name, response.value),
      }));

      return {
        ...acc,
        results: [...acc.results, { name, data: dataWithFill }],
      };
    },
    { results: [], maxValue: 0 }
  );

export default getRenderData;
